import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpTitle_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpStrapline_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { helpTitle: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpTitle_TextField>, helpStrapline: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpStrapline_TextField> }
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { helpTitle: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpTitle_TextField>, helpStrapline: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpStrapline_TextField> }
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { helpTitle: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpTitle_TextField>, helpStrapline: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpStrapline_TextField> }
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
);

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults_results = HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionPresentation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AccordionPresentationFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AddThisParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AggregatedFacetFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AlertMessageType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Archive | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleAuthor | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleCategory | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleChapter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleChapters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleContentType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFilterOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnote | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnoteLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleFootnoteText | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleInfogramTile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticlePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleRegion | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleRegionsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSeriesCollection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSeriesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTag | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTagsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTeamAuthor | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ArticlesGroupFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AttachThemeExtension | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AutomaticDocumentListings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableJSONRenderings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableMetaRenderings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableRenderings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerImage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BackgroundColorOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BannerTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BaseHeading | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BaseHeadingFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BoolFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BranchesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Breadcrumb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_BrowserTitleDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CORSEntry | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CORSGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CTAPresentationType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AbrdnPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ActionBase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AdvancedParameter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__App | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseCTA | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__BaseVariantField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Class | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__CompositeGroup | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__CompositeSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__EloquaForm | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridItemBase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__GridParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HeadlessSite | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HeadlessTenant | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IAllowEmpty | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IBoosting | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ICacheable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IComponentVariant | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IControlType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IIcon | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ILocation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPaginable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPagination | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IPoi | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IRenderingId | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ISplitter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IStyling | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__IVariantDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSONField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSONReference | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSData | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JSSSiteFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__JssRootFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Page | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageData | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesignFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesign | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesignFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__Route | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SimpleVideo | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__SitemapSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__StandardTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__TrustFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C__VariantsGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___AdvancedItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Arguments | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Article | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticleSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ArticleWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseDataFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseJSSTenant | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePageDesign | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePartialDesign | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePlaceholder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePresentation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BasePressRelease | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseSiteRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseTenant | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseTenantFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BucketRules | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___CORS | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Content | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ContentType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DataAttributes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Dependencies | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Description | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Designable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___EditingTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Enabled | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ErrorHandling | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ExternalArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Fields | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Footnotes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundFormAvailability | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundMetadataPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsFormsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___GridMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Icon | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IncludeByDefault | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___InternalArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___IsSystemModule | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___JSONVariantPaging | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___JSONVariantsBase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LimitedDisplay | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LinkAttributes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LinkSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ManualKeyInformation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___MemberOf | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___MetadataPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Modules | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Navigable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___NavigablePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PageContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PageWorkflow | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Podcast | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PodcastPressRelease | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PremiumContentPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressRelease | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseContentType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___ProtectedTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RenderingsList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RobotsContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleDomain | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleName | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___RoleType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldId | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Script | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SearchSignature | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Searchable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SecurityItemPointer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedArticles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedHelpArticles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedPressReleases | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SharedSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SiteTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Sitemap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SitemapMediaItems | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SolutionTemplateName | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SortOrder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___StackBreakpoint | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Statistics | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___SupportedLanguages | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Taggable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___TechzoneArticle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Template | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Title | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Type | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Validation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VariantPaging | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VectorTile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VectorTileLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Video | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___VideoPressRelease | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___Width | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___WildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CacheSetting | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CalendarEvent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallToAction | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CallToActionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilitiesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Capability | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilityMap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CapabilityMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Carousel | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CarouselFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CarouselSlide | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Checkbox | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ColumnSplitter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CompatibilityMode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ComponentsConfigurations | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ConfigurationFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Container | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerOptionsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContainerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentBlock | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentBlockFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentToken | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentTokenFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ContentType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CorporateTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CorporateThemesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Country | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CountryISOCode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CountryISOCodesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewTile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeFund | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataBridgeShareClass | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DataFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceConfigurations | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultColumnLayout | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultShareclassMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DefaultShareclassMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlight | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Device | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Devices | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DictionaryFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DisqusParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DistanceFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Divider | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentListings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentListingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DocumentTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DominantLanguageMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Dropdown | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditEditingTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditFrame | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditModePanel | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditSiteTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditTenantTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EditType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EloquaFormFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EloquaFundForm | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Enum | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Enums | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventCalendarParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventListParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventTypes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_EventsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExtendSiteTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ExternalLiterature | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSlider | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSliderFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummary | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummaryFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FacetsGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FakeNavigationItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeatureBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedArticles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeaturedThemesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Feed | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeedFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FeedParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FieldEditor | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FieldRenderer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileListFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FileListParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterCriteria | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterCriteriaFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterTaxonomyOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flip | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FlipFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Flipside | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FloatFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Footer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FooterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FooterLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FormRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundAssetClass | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundAssetClassesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundFormsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundInFocus | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundInFocusShareClass | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSubAssetClass | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsInFocusFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsLiteratureFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Gallery | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryImage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GalleryVideo | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GatedAccordionContainer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GlobalLanguageSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GlobalNavigationBar | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleAnalytics | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleTagManager | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GridSetup | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_GridTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLCode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLCodeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLInclude | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLIncludesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLSnippet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLSnippetFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HTMLTag | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Header | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeaderFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Heading | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessTrustSite | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessVariants | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatform | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleTag | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpTagMap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HelpTagMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HeroBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Highlight | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlock | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlockFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HighlightParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Home | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrameParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Icon | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IconFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ImageParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Infographics | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InfographicsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntegerFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntroCopy | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_IntroCopyFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustRegion | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustStyle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestorType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_InvestorTypesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ItemQueriesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ItemRights | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSBeaconSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONCheckbox | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONDate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONFile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONImage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONLayout | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONMultilistReference | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONPlaceholder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONQuery | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONResults | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONRichText | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONScriban | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONText | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONToken | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONVariantDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSONVariants | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSLayout | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSSiteGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JSSTenantFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JavaScriptRendering | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JsonRendering | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JurisdictionStatus | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_JurisdictionsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlights | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Language | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LanguageSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LanguagesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LayoutServiceVariants | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LimitedDisplayFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LimitedDisplayOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkListFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LinksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_List | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListFacet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListStyle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListStyleItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListingHeroBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureAuthorization | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMore | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMoreFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Log | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Login | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlockItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlocks | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Logout | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ManagedRangeItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Map | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MapsProvider | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlock | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlockFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaLinkParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MediaVirtualFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MegaNavigation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MegaNavigationFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetaBranding | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetaRenderingParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MetadataPartialDesign | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Model | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ModelIterator | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_MyLocationPOI | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Navigation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationCategory | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_NavigationSubcategory | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OneTrustSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimiserConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OptimizedFile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OracleCDPSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OverlayContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OverlayFolderTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Ownership | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_OwnershipFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POI | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_POIs | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageBranchesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContentFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesign | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageLevelTabs | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageLevelTabsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelectorConfiguration | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelectorFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSize | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSizeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PageThemesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Pagging | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Pagination | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PaginationFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Paragraph | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Playlist | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaylistFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Podcast | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PodcastPressReleasePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PoiTypes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Presentation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseContentType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePlatform | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PrivacyWarning | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ProjectFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromoFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromotedContent | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PromotedContentFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCards | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingCategory | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_PropertyListingFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinks | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlockItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocks | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Quote | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuoteFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_QuoteParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusScheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RadiusSchemeValue | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RecentArticles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Redirect | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RedirectMap | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RedirectMaps | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Region | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RegionLanguages | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RegionLanguagesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RelatedArticles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderEngineType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RenderingHost | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResponsiveImage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCount | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCountFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ResultsVariantSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichTextFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskImageMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskImageMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskLevelOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarning | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarningFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RolePlaceholder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RowSplitter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Rule | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRLogoMapping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRLogoMappings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRTypeOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXAJSSLayout | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXARole | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceAlertMessage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceCheckBox | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDateInput | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDropdown | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceDropdownOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceHiddenField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceInput | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceInputType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceRichTextArea | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SalesforceSubmissionType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scope | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ScopesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scriban | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Scripts | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBox | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBoxFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResults | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResultsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeading | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelectorFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SectionSelectorTab | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Series | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SeriesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Settings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SettingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharePriceSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedArticlesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedContentFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSettingsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSitesSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Showcase | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Site | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteContentFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteDefinition | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteGrouping | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteManagement | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSelector | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteSetupRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SiteTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitecoreRole | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLinkParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SkipLinksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Snippet | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SnippetItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SnippetsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialLoginWrapper | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaButtons | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaShare | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialMediaTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetwork | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetworkFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SocialNetworkLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SolutionTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortResults | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortResultsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Sorting | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SortingGroups | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SpotifyPodcast | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTA | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTAFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_StrategyInFocus | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Style | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Styles | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tab | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TabItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContents | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TableOfContentsSubsection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tabs | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TabsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tag | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagCloud | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TagList | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamBiographySettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamListingCards | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamListingCardsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMember | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMemberCard | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembers | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamProfileCards | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TechzoneArticlePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tenant | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TenantSetupRoot | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TertieryHeroBanner | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Text | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlock | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockLinkType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocks | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocksFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Theme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemeTag | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemeTagsFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemingMode | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ThemingModes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Tile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileSizeOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TileSizeOptionFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TilesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TilesParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Title | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Toggle | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_ToggleFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Transformation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustFinder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustFinderFilterOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustRegion | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustType | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TrustTypesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Twitter | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterApp | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterApps | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_TwitterSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UnknownItem | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UnminifiedFile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UpgradeScript | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantComponentField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantDateField | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantPlaceholder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantReference | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantSection | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantText | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VariantToken | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Variants | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTile | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTileLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTilesFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Video | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoCountOption | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoCountOptions | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoFolder | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoPage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoParameters | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoParametersTemplate | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_VideoPressReleasePage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__AssetsOptimization | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__BackgroundImage | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CompatibleThemes | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CompositeTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CustomMetadata | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__CustomRenderingViewPath | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__DatasourceBehaviour | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Favicon | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__FormsFolderLocation | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__FundSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__HasValidUrlName | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__LocalDataLink | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Login | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__OpenGraphMetadata | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__PageDesignTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__PageSearchScope | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SearchCriteria | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SeoMetadata | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SiteTheme | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__SitemapSettings | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__StickyNote | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Styleable | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__TwitterMetadata | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__Webinar | HelpArticleSearchRelatedQuery_search_ItemSearchResults_results__WildcardSource;

export type HelpArticleSearchRelatedQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: HelpArticleSearchRelatedQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results>> }
);

export type HelpArticleSearchRelatedQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults> }
);


export type HelpArticleSearchRelatedQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
  siteId: Types.Scalars['String']['input'];
  pageSize: Types.Scalars['Int']['input'];
  currentArticleId: Types.Scalars['String']['input'];
  tags: Array<Types.ItemSearchPredicateInput> | Types.ItemSearchPredicateInput;
}>;


export type HelpArticleSearchRelatedQuery = HelpArticleSearchRelatedQuery_Query;

export type HelpArticleLinkFragment = (
  { __typename?: 'C___BaseHelpArticle' | 'C___HelpArticle' | 'HelpArticlePage' }
  & { helpTitle: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpTitle_TextField>, helpStrapline: Types.Maybe<HelpArticleSearchRelatedQuery_search_ItemSearchResults_results_C___BaseHelpArticle_helpStrapline_TextField> }
);

export const HelpArticleLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HelpArticleLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseHelpArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"helpStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<HelpArticleLinkFragment, unknown>;
export const HelpArticleSearchRelatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpArticleSearchRelated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentArticleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemSearchPredicateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"88A0C80A45D04FE192AB4647960107CC","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"D3BECD5C437B44C8BF7FFB15BB5CA09B","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"shareTo","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentArticleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"NCONTAINS"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HelpArticleLink"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HelpArticleLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseHelpArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"helpStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<HelpArticleSearchRelatedQuery, HelpArticleSearchRelatedQueryVariables>;